import React, { useContext } from 'react'
import { bool, func } from 'prop-types'
import styled from 'styled-components'
import { Link, navigate } from 'gatsby'

import { fontWeights, Lead } from 'styles/typography'
import { black } from 'styles/colors'

import Modal, { ModalSection } from 'components/Modal'
import NativeAuth from 'components/NativeAuth'
import CheckoutContext from 'contexts/Checkout'
import Button from 'components/button/Button'
import ButtonGroup from 'components/button/ButtonGroup'

const Container = styled.div`
  text-align: center;
`

const Heading = styled(Lead)`
  font-weight: ${fontWeights.medium};
  color: ${black};
  margin-bottom: 1rem;
`

const SubscriptionModal = () => {
  const { regularLineItemsQuantity } = useContext(CheckoutContext)
  const { subscriptionModalVisible, setSubscriptionModalVisible } = useContext(NativeAuth)

  const hasRegularOrder = regularLineItemsQuantity > 0

  return (
    <Modal
      visible={subscriptionModalVisible}
      close={() => {
        setSubscriptionModalVisible(false)
      }}
      wide
    >
      <ModalSection>
        <Container>
          <Heading>It looks like you already have an active subscription in your Account.</Heading>
          {hasRegularOrder ? (
            <p>
              You can proceed to checkout for your One Time Purchase. Meanwhile, we have saved what you added for
              subscription as a <strong>draft order</strong> in your{' '}
              <Link
                to="/account/subscriptions/"
                onClick={() => {
                  setSubscriptionModalVisible(false)
                }}
              >
                <strong>Account</strong>
              </Link>{' '}
              page where you can add/modify to your current subscription order.
            </p>
          ) : (
            <p>
              We have saved what you added for subscription as a <strong>draft order</strong> in your{' '}
              <Link
                to="/account/subscriptions/"
                onClick={() => {
                  setSubscriptionModalVisible(false)
                }}
              >
                <strong>Account</strong>
              </Link>{' '}
              page where you can add/modify to your current subscription order.
            </p>
          )}
          <ButtonGroup>
            {hasRegularOrder && (
              <Button
                theme="primary"
                type="button"
                onClick={() => {
                  setSubscriptionModalVisible(false)
                  navigate('/checkout/')
                }}
              >
                Proceed to checkout
              </Button>
            )}
            <Button
              theme="primary"
              type="button"
              onClick={() => {
                setSubscriptionModalVisible(false)
                navigate('/account/subscriptions/')
              }}
            >
              Go to account
            </Button>
          </ButtonGroup>
        </Container>
      </ModalSection>
    </Modal>
  )
}

SubscriptionModal.propTypes = {
  visible: bool.isRequired,
  close: func.isRequired
}

export default SubscriptionModal
